import { BaseButton } from 'app/components/buttons/BaseButton';
import { MoreIcon } from 'app/components/icons';
import { ActionsListItem, Menu } from 'app/components/menu';
import clsx from 'clsx';
import React, { useCallback, useMemo, useState } from 'react';
import './EllipsisMenu.less';

interface Props {
  actions: ActionsListItem[];
  menuClassName?: string;
}

export default function EllipsisMenu({ actions, menuClassName }: Props) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | undefined>(undefined);

  const handleMenuClose = useCallback(() => {
    setAnchorEl(undefined);
  }, []);

  const handleMenuOpen = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();

      const element = event.currentTarget;

      setAnchorEl(prev => (!prev ? element : undefined));
    },
    [],
  );

  const hasActiveActions = useMemo(
    () => actions.some(({ exclude }) => !exclude),
    [actions],
  );

  if (!hasActiveActions) {
    return null;
  }

  return (
    <>
      <BaseButton
        className={clsx('ellipsis-menu__button', {
          'ellipsis-menu__button_open': anchorEl,
        })}
        onClick={handleMenuOpen}
      >
        <MoreIcon />
      </BaseButton>

      <Menu
        menuClassName={menuClassName}
        anchorEl={anchorEl}
        actions={actions}
        onClose={handleMenuClose}
      />
    </>
  );
}
